export const styles = {
  row: 'tw-border-b tw-border-neutral-100 last:tw-border-b-0',
  cellContainer: 'tw-flex tw-items-center tw-gap-4 tw-p-3',
  keyCell:
    'tw-min-w-[160px] tw-max-w-[200px] tw-font-semibold tw-text-neutral-900 tw-text-sm tw-truncate',
  valueCell: 'tw-flex-1 tw-text-sm tw-text-neutral-600 tw-break-words tw-whitespace-pre-wrap',
  nullChip: 'tw-bg-amber-100 tw-text-amber-700',
  actionsCell: 'tw-flex tw-items-center tw-gap-1 tw-shrink-0 tw-ml-auto',
  editContainer: 'tw-flex tw-flex-col tw-gap-2 tw-flex-1',
  editActions: 'tw-flex tw-items-center tw-gap-2',
  textarea:
    'tw-w-full tw-min-h-[80px] tw-p-2 tw-border tw-border-neutral-300 tw-rounded tw-text-sm tw-font-mono tw-resize-y focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-500 focus:tw-border-primary-500',
  input:
    'tw-w-full tw-p-2 tw-border tw-border-neutral-300 tw-rounded tw-text-sm tw-font-mono focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-500 focus:tw-border-primary-500',
};
